'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _shopifySectionsManager = require('shopify-sections-manager');

var _shopifySectionsManager2 = _interopRequireDefault(_shopifySectionsManager);

var _StaticSearch = require('../sections/StaticSearch');

var _StaticSearch2 = _interopRequireDefault(_StaticSearch);

require('intersection-observer');

var _rimgShopify = require('rimg-shopify');

var _rimgShopify2 = _interopRequireDefault(_rimgShopify);

require('../../styles/templates/search.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Search = function Search() {
  (0, _classCallCheck3.default)(this, Search);

  var sections = window.shopifySections || new _shopifySectionsManager2.default();
  sections.register('static-search', function (section) {
    return new _StaticSearch2.default(section);
  });

  _rimgShopify2.default.init();
};

exports.default = Search;


new Search();